export default __webpack_public_path__ + "static/media/5_Intro.a1c8ceb0.mp4";